import { Formik } from 'formik';
import React from 'react';
import InputFormItem from '../../../components/FormItems/items/InputFormItem';
import RadioFormItem from '../../../components/FormItems/items/RadioFormItem';
import usersFields from '../usersFields';
import IniValues from '../../../components/FormItems/iniValues';
import PreparedValues from '../../../components/FormItems/preparedValues';
import FormValidations from '../../../components/FormItems/formValidations';
import Widget from '../../../components/Widget/Widget';
import { Col, Row } from 'reactstrap';
import SwitchFormItem from '../../../components/FormItems/items/SwitchFormItem';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const UsersForm = ({ saveLoading, onSubmit }) => {
  const { t } = useTranslation();

  const iniValues = () => {
    return IniValues(usersFields, {
      role: 'ROLE_COMPANY',
      active: true,
    });
  };

  const formValidations = () => {
    return FormValidations(usersFields, {});
  };

  const handleSubmit = (values) => {
    const data = PreparedValues(usersFields, values || {});
    onSubmit(null, data);
  };


  return (
    <Widget>
      <Formik
        onSubmit={handleSubmit}
        initialValues={iniValues()}
        validationSchema={formValidations()}
      >
        {(form) => (
          <form onSubmit={form.handleSubmit}>
            <Row>
              <Col md={6}><InputFormItem name={'username'} schema={usersFields} required /></Col>
              <Col md={6}><InputFormItem name={'personalNr'} schema={usersFields} /></Col>
            </Row>

            <Row>
              <Col md={6}><InputFormItem name={'firstname'} schema={usersFields} /></Col>
              <Col md={6}><InputFormItem name={'lastname'} schema={usersFields} /></Col>
            </Row>

            <Row>
              <Col md={6}><InputFormItem name={'email'} schema={usersFields} required /></Col>
              <Col md={6}><InputFormItem name={'phone'} schema={usersFields} /></Col>
            </Row>

            <Row>
              <Col md={6}><InputFormItem password name={'plainPassword'} schema={usersFields} required /></Col>
              <Col md={6}><InputFormItem password name={'confirmPassword'} schema={usersFields} /></Col>
            </Row>

            {/* Uncomment if necessary */}
            <RadioFormItem name={'role'} schema={usersFields} />

            <SwitchFormItem name={'active'} schema={usersFields} />

            {/* <ImagesFormItem
              name={'avatar'}
              schema={usersFields}
              path={'users/avatar'}
              fileProps={{
                size: undefined,
                formats: undefined,
              }}
              max={undefined}
            /> */}

            <div className="form-buttons">
              <button
                className="me-3 btn btn-success"
                disabled={saveLoading}
                type="button"
                onClick={form.handleSubmit}
              >
                {t("Save")}
              </button>

              <button
                className="me-3 btn btn-gray-default"
                type="button"
                disabled={saveLoading}
                onClick={form.handleReset}
              >
                {t("Reset")}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </Widget>
  );
};

export default UsersForm;
